import {Injectable} from '@angular/core';
import {BreakpointObserver, BreakpointState} from '@angular/cdk/layout';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScreenService {
  private isMobileSubject = new BehaviorSubject<boolean>(false);
  public isMobile$: Observable<boolean> = this.isMobileSubject.asObservable();

  private isMediumSubject = new BehaviorSubject<boolean>(false);
  public isMedium$: Observable<boolean> = this.isMediumSubject.asObservable();

  private isAuthenticatingSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticating$: Observable<boolean> = this.isAuthenticatingSubject.asObservable();

  private fontsLoadedSubject = new BehaviorSubject<boolean>(false);
  public fontsLoaded$ = this.fontsLoadedSubject.asObservable();

  constructor(private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe((result: BreakpointState) => {
      this.isMobileSubject.next(result.matches);
    });

    this.breakpointObserver.observe(['(min-width: 600px) and (max-width: 1515px)']).subscribe((result: BreakpointState) => {
      this.isMediumSubject.next(result.matches);
    });
  }

  set isAuthenticating(value: boolean) {
    this.isAuthenticatingSubject.next(value);
  }

  fontsLoaded(): void {
    const fontsToCheck = [
      '12px "Material Symbols Rounded"',
      '12px "Geist"',
    ];

    const checkFont = () => {
      document.fonts.ready
        .then(() => {
          const isFontLoaded = fontsToCheck.every(font => document.fonts.check(font));
          if (isFontLoaded) {
            this.fontsLoadedSubject.next(true);
          } else {
            // Reintentar después de un breve delay si la fuente no está cargada
            setTimeout(checkFont, 100);
          }
        })
        .catch(() => {
          // Reintentar después de un breve delay en caso de error
          setTimeout(checkFont, 100);
        });
    };

    // Iniciar el proceso de verificación
    checkFont();
  }
}
